export default __webpack_public_path__ + "static/media/L.991e2911.svg";